import { ecoType } from '../const';
import protocol from '../protocol/index';

var setTitle = function setTitle(title) {
  if (ecoType === 'dingTalk') {
    var configProtocol = protocol(ecoType);
    return configProtocol('biz.navigation.setTitle', {
      title: title
    });
  } else {
    return document.title = title;
  }
};

export default setTitle;